<h1 mat-dialog-title>{{ data.modalTitle }} <span *ngIf="data.subStructure"> - {{ data.subStructure }}</span></h1>
<mat-dialog-content id="dataToPrint">
  <div class="col-12" style="margin-bottom: 30px; page-break-after: always;">
    <div class="row" style="margin-bottom: 10px;">
      <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
        <qrcode #qrdata [qrdata]="qrcodeData" [width]="150" [errorCorrectionLevel]="'H'" [elementType]="'url'"></qrcode>
        <div style="margin-top: 5px; font-size: 0.7rem;" *ngIf="data.barCode">{{ data.barCode }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-12" style="clear: both; text-align: left;">
        <!-- DATI IMMOBILE -->
        <div class="row">
          <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
            <div style="margin-bottom: 0.7rem; font-size: 0.7rem;">
              <strong>{{ 'properties.dialog.propertyData' | translate }}</strong>
            </div>
            <div style="clear: both; display: flex;">
              <div style="float: left; width: 200px; margin-right: 8px;">
                <strong>{{ 'properties.dialog.property' | translate }}</strong>
              </div>
              <div style="float: left; width: 300px">{{ data.name }}</div>
            </div>
            <div style="clear: both; display: flex;">
              <div style="float: left; width: 200px; margin-right: 8px;">
                <strong>{{ 'properties.dialog.city' | translate }}</strong>
              </div>
              <div style="float: left; width: 300px">{{ data.city }}</div>
            </div>
            <div style="clear: both; display: flex;">
              <div style="float: left; width: 200px; margin-right: 8px;">
                <strong>{{ 'properties.dialog.address' | translate }}</strong>
              </div>
              <div style="float: left; width: 300px">{{ data.address }}</div>
            </div>
            <div style="clear: both; display: flex;">
              <div style="float: left; width: 200px; margin-right: 8px;" *ngIf="data.itemData && data.itemData.createdAt">
                <strong>{{ 'properties.dialog.uploadDate' | translate }}</strong>
              </div>
              <div style="float: left; width: 300px">{{ data.itemData.createdAt | date }}</div>
            </div>
            <div style="clear: both; display: flex;" *ngIf="data.subArea">
              <div style="float: left; width: 200px; margin-right: 8px;">
                <strong>{{ 'properties.dialog.area' | translate }}</strong>
              </div>
              <div style="float: left; width: 300px">{{ 'properties.addDocumentsPage.area.' + data.subArea | translate }}
              </div>
            </div>
            <div style="clear: both; display: flex; margin-bottom: 20px;" *ngIf="data.subStructure">
              <div style="float: left; width: 200px; margin-right: 8px;">
                <strong>{{ 'properties.dialog.argument' | translate }}</strong>
              </div>
              <div style="float: left; width: 300px">{{ data.subStructure }}
              </div>
            </div>
          </div>
        </div>
        <!-- DATI MODULO DOCUMENTO -->
        <div class="row" *ngIf="data.area || data.topic || (data.structure && data.structure!='')">
          <div class="col-12" style="font-family: sans-serif; font-size: 0.6rem;">
            <div style="margin-bottom: 0.7rem; font-size: 0.7rem;">
              <strong>{{ 'properties.dialog.documentData' | translate }}</strong>
            </div>
            <div class="row">
              <div class="col-12" style="margin-bottom: 10px; clear: both; display: flex;">
                <div style="float: left; margin-right: 8px;">
                  <strong>{{ 'properties.dialog.content' | translate }}:</strong>
                </div>
                <div style="float: left; font-family: sans-serif;" *ngIf="data.itemData && data.itemData.contenutoDocumento">
                  {{ data.itemData.contenutoDocumento }}
                </div>
                <br>
              </div>
            </div>
            <div class="row" style="display: flex">
              <div class="col-4" style="flex: 0 0 33.333333%; max-width: 33.333333%;">
                <div style="float: left; margin-right: 8px; margin-bottom: 0.5rem;">
                  <strong>{{ 'properties.dialog.topic' | translate }}</strong>
                </div>
                <br>
                <div style="float: left; width: 100%; margin-bottom: 0.2rem;" *ngIf="data.topic">
                  {{ data.topic }}
                </div>
              </div>
              <div class="col-4" style="flex: 0 0 33.333333%; max-width: 33.333333%;">
                <div style="float: left; margin-right: 8px; margin-bottom: 0.5rem;">
                  <strong>{{ 'properties.dialog.structure' | translate }}</strong>
                </div>
                <br>
                <div 
                  style="float: left; width: 100%; margin-bottom: 0.2rem;" *ngIf="data.structure && data.structure!=''">
                  {{ data.structure }}
                </div>
              </div>
              <div class="col-4" style="flex: 0 0 33.333333%; max-width: 33.333333%;">
                <div style="float: left; margin-right: 8px; margin-bottom: 0.5rem;">
                  <strong>{{ 'properties.dialog.type' | translate }}</strong>
                </div>
                <br>
                <div style="float: left; width: 100%; margin-bottom: 0.2rem;" *ngIf="data.modalTitle">
                  {{ data.modalTitle }}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-12" style="width: 100%; font-family: sans-serif; font-size: 0.6rem;">
            <div style="margin-top: 30px; text-align-last: center;">
              <img src="https://wa.archedi.it/assets/img/logo/logo.png" alt="{{ configService.ownerNicename }}"
                height="20">
              <div style="margin-top: 5px;">
                &copy; Archedi {{ year }}, tutti i diritti riservati
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<div mat-dialog-actions>
  <div class="row w-100 mt-5">
    <div class="col-12 col-md-3 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div> <!-- /.col -->
    <div class="col-12 col-md-3 text-left" *ngIf="qrcodeData !== ''" >
      <a mat-button (click)="onSaveQRAsImage(qrdata)" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.download' | translate }}</a>
    </div>
    <div class="col-12 col-md-6 text-right">
      <a mat-button (click)="onPrint()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.print' | translate }}</a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>